import * as aa from "../generated/UserAPIAgent";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaymentPlanEnum } from "../generated/UserAPIAgent";

export interface PaymentState {
    token: string | null;
    status: aa.PaymentStatusObj | null;
    inProgress: boolean;
    selectedPayment: NewPayment | null;
    isChangeCardInfoInProgress: boolean;
}

export interface NewPayment {
    paymentPlanId: PaymentPlanEnum;
    campaignId: string | null;
    amount: number;
    firstAmount: number | null;
}

const initialState: PaymentState = {
    token: null,
    status: null,
    inProgress: false,
    selectedPayment: null,
    isChangeCardInfoInProgress: false
};

const paymentSlice = createSlice({
    name: "payment",
    initialState,
    reducers: {
        paymentTokenSet: (state, action: PayloadAction<string | null>) => {
            state.token = action.payload;
        },
        paymentStatusSet: (
            state,
            action: PayloadAction<aa.PaymentStatusObj | null>
        ) => {
            state.status = action.payload;
        },
        paymentInProgressSet: (state, action: PayloadAction<boolean>) => {
            state.inProgress = action.payload;
        },
        selectedPaymentSet: (
            state,
            action: PayloadAction<NewPayment | null>
        ) => {
            state.selectedPayment = action.payload;
        },
        isChangeCardInfoInProgressSet: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.isChangeCardInfoInProgress = action.payload;
        }
    }
});

export const paymentActions = paymentSlice.actions;
export const paymentReducer = paymentSlice.reducer;
